import React from 'react';
import { Select, MenuItem, FormControl } from '@mui/material';
import { ChevronDown } from 'lucide-react';

const SelectComponent = ({
  value,
  onChange,
  options = [],
  onOpen,
  onClose,
  isOpen = false,
  width,
  height = '36px',
  icon = null,
  placeholder = 'Select option',
  label = null
}) => {
  // Default width if not provided
  const selectWidth = width || '240px';
  return (
    <div>
      {label && (
        <label
          className="block mb-2"
          style={{
            fontFamily: 'Inter',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '120%',
            color: '#1F2937'
          }}
        >
          {label}
        </label>
      )}
      <div className="relative" style={{ width: selectWidth, height, maxWidth: selectWidth }}>
        {icon && (
          <img
            src={icon}
            alt="icon"
            className="absolute z-[5] w-4 h-4 transform -translate-y-1/2 pointer-events-none left-3 top-1/2"
          />
        )}
        <FormControl size="small" style={{ width: selectWidth, height }}>
          <Select
            value={value}
            onChange={onChange}
            onOpen={onOpen}
            onClose={onClose}
            IconComponent={ChevronDown}
            displayEmpty
            renderValue={(selected) => {
              if (!selected || selected === '') {
                return <span style={{ color: '#9CA3AF', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', display: 'block', maxWidth: '100%' }}>{placeholder}</span>;
              }
              const selectedOption = options.find(option => option.value === selected);
              return (
                <span style={{
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'block',
                  maxWidth: '100%'
                }}>
                  {selectedOption ? selectedOption.label : selected}
                </span>
              );
            }}
            sx={{
              width: selectWidth,
              height,
              borderRadius: '8px',
              paddingLeft: icon ? '36px' : '12px',
              boxShadow: '0px 1px 2px 0px #0000000A',
              '& .MuiOutlinedInput-notchedOutline': {
                borderRadius: '8px',
                border: '1px solid #D7D7D7'
              },
              '& .MuiSelect-select': {
                paddingLeft: '0px',
                paddingRight: '12px',
                paddingTop: '0px',
                paddingBottom: '0px',
                lineHeight: '34px',
                height,
                display: 'flex',
                alignItems: 'center'
              },
              '& .MuiSelect-icon': {
                right: '12px',
                color: '#9CA3AF',
                top: '50%',
                transform: `translateY(-50%) ${isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}`,
                transition: 'transform 0.2s'
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#D1D5DB',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#1A77F2',
                borderWidth: '1px',
              }
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  mt: '8px',
                  borderRadius: '8px',
                  zIndex: 5,
                  '& .MuiMenuItem-root': {
                    padding: 0,
                    '& span': {
                      display: 'block',
                      paddingLeft: '8px',
                      paddingRight: '8px',
                      paddingTop: '12px',
                      paddingBottom: '12px',
                      borderRadius: '4px',
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '140%',
                      transition: 'background 0.2s',
                      '&:hover': {
                        backgroundColor: '#F3F3F3'
                      }
                    }
                  }
                }
              }
            }}
          >
            {options.map((option, index) => (
              <MenuItem key={option.value || index} value={option.value || option}>
                <span style={{
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'block',
                  // maxWidth: selectWidth == '100px' ? '90px' : '220px'
                  maxWidth: selectWidth ? selectWidth : '220px'
                }}>{option.label || option}</span>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default SelectComponent;
